import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { collection, query, where, getDocs } from "firebase/firestore";
import { toast } from "react-toastify";
import { db } from "../../firebase-config";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Footer from "../Footer/Footer";
import Navbar from "../nav/navbar/Navbar";
import Sidebar from "../sidebar/Sidebar";
import Navmenu from "../nav/navmenu/Navmenu";
import Shopbycat from "../Shopbycat/Shopbycat";
import "./productdetail.css";
import SimpleBottomNavigation from "../BottomNav/SimpleBottomNavigation";
import CircleIcon from "@mui/icons-material/Circle";
import StarIcon from "@mui/icons-material/Star";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ShareButton from "../../components/ShareButton";

const Productdetail = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });
  const isOpen = useSelector((state) => state.sidebar);
  const { ProductName } = useParams();
  const [product, setProduct] = useState(null);
  const [mainImage, setMainImage] = useState(null); // State for the main image
  const [lowQualityImage, setLowQualityImage] = useState(null); // Low-quality placeholder
  const [selectedSize, setSelectedSize] = useState("2.6"); // Selected size
  const navigate = useNavigate();
  const [wishlist, setWishlist] = useState(
    JSON.parse(localStorage.getItem("wishlist")) || []
  );
  useEffect(() => {
    const fetchProduct = async () => {
      if (ProductName) {
        const productsRef = collection(db, "products");
        const q = query(productsRef, where("ProductName", "==", ProductName));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          const productData = doc.data();
          setProduct(productData);
          setMainImage(productData.ProductImgs.high[0]);
          setLowQualityImage(productData.ProductImgs.low[0]);
        });
      } else {
        console.error("Product name not provided in URL");
      }
    };

    fetchProduct();
  }, [ProductName]);

  if (!product) {
    return null; // Render nothing until product data is fetched
  }

  const addtocart = (product) => {
    const existingCartItems = JSON.parse(localStorage.getItem("incart")) || [];
    const existingProductIndex = existingCartItems.findIndex(
      (item) => item.id === product.id && item.size === selectedSize
    );

    if (existingProductIndex >= 0) {
      existingCartItems[existingProductIndex].quantity += 1;
    } else {
      const productWithQuantity = {
        ...product,
        size: selectedSize,
        quantity: 1,
      };
      existingCartItems.push(productWithQuantity);
    }

    localStorage.setItem("incart", JSON.stringify(existingCartItems));

    toast.success("Product added to Cart.", { position: "top-left" });
  };
  const toggleWishlist = (product) => {
    const isWishlisted = wishlist.some((item) => item.id === product.id);
    const updatedWishlist = isWishlisted
      ? wishlist.filter((item) => item.id !== product.id)
      : [...wishlist, product];

    setWishlist(updatedWishlist);
    localStorage.setItem("wishlist", JSON.stringify(updatedWishlist));

    toast.success(
      isWishlisted ? "Removed from wishlist." : "Added to wishlist.",
      {
        position: "top-right",
      }
    );
  };

  return (
    <>
      <Navbar />
      {isMobile ? isOpen ? <Sidebar /> : null : <Navmenu />}
      <div className="product-details-container">
        <div className="productimage">
          <div className="thumbnail-images">
            {product.ProductImgs.low.map((imgSrc, index) => (
              <img
                key={index}
                src={imgSrc}
                alt={`Product Thumbnail ${index + 1}`}
                className={`thumbnail-img ${
                  imgSrc === mainImage ? "active" : ""
                }`}
                loading="lazy"
                onClick={() => {
                  setLowQualityImage(product.ProductImgs.low[index]);
                  setMainImage(product.ProductImgs.high[index]);
                }}
              />
            ))}
          </div>
          <div className="large-image">
            <img
              src={mainImage}
              alt="Main Product"
              className="main-product-img"
              loading="lazy"
              srcSet={`${lowQualityImage} 300w, ${mainImage} 800w`}
            />
          </div>
        </div>
        <span className="made">Made with {product.Purity}{` `}{product.MetalType}</span>
           <div className="ratingnwishlist">
        <div className="rating">
          {" "}
          <StarIcon /> ( 4.2 | 56 )
          {/* {product.ProductRating} */}
        </div>
        <div className="ratingnwishlist">
        <div className="wishlistAdd" onClick={() => toggleWishlist(product)}>
          {wishlist.some((item) => item.id === product.id) ? (
            <FavoriteIcon className="heart-icon active" />
          ) : (
            <FavoriteBorderIcon className="heart-icon" />
          )}
          
        </div>
        <div className="share" >
        <ShareButton productUrl={`https://shagoon.online/product/${product.ProductName}`} />

          </div>
          </div>
        </div>
        <div className="product-info">
          <h2 className="product-name">{product.ProductName}</h2>

          <div className="product-specs">
            <h3>Select Size:</h3>
            <div className="size-buttons">
              {["2.2", "2.4", "2.6", "2.8", "2.10", "2.12"].map((size) => (
                <button
                  key={size}
                  className={`size-button ${
                    selectedSize === size ? "active" : ""
                  }`}
                  onClick={() => setSelectedSize(size)}
                >
                  {size}
                </button>
              ))}
            </div>
            <p className="spec">Metal Weight: {product.metalWeight}</p>
          </div>

          <Accordion style={{ width: "100%", margin: "10px 0px" }}>
            <AccordionSummary
              expandIcon={
                <ExpandMoreIcon style={{ color: "var(--firstbackground)" }} />
              }
              aria-controls="product-description-content"
              id="product-description-header"
              style={{
                backgroundColor: "var(--highlight)",
                color: "var(--firstbackground)",
                fontSize: "16px",
              }}
            >
              <Typography style={{ fontWeight: "600" }}>Description</Typography>
            </AccordionSummary>
            <AccordionDetails
              style={{
                padding: "16px",
                backgroundColor: "var(--highlight)",
                color: "var(--firstbackground)",
                fontSize: "16px",
              }}
            >
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                <li>
                  <CircleIcon
                    style={{
                      fontSize: "small",
                      color: "var(--firstbackground)",
                    }}
                  />{" "}
                  Per gram metal price with 29% off.
                </li>
                <li>
                  <CircleIcon
                    style={{
                      fontSize: "small",
                      color: "var(--firstbackground)",
                    }}
                  />{" "}
                  Gentle on skin, designed to be easy to wear.
                </li>
                <li>
                  <CircleIcon
                    style={{
                      fontSize: "small",
                      color: "var(--firstbackground)",
                    }}
                  />{" "}
                  100% exchange value of silver for a lifetime.
                </li>
                <li>
                  <CircleIcon
                    style={{
                      fontSize: "small",
                      color: "var(--firstbackground)",
                    }}
                  />{" "}
                  Advanced coating for lasting shine.
                </li>
                <li>
                  <CircleIcon
                    style={{
                      fontSize: "small",
                      color: "var(--firstbackground)",
                    }}
                  />{" "}
                  Elegant and collectible design.
                </li>
                <li>
                  <CircleIcon
                    style={{
                      fontSize: "small",
                      color: "var(--firstbackground)",
                    }}
                  />{" "}
                  Available in multiple sizes.
                </li>
                <li>
                  <CircleIcon
                    style={{
                      fontSize: "small",
                      color: "var(--firstbackground)",
                    }}
                  />{" "}
                  Visit our website for more options.
                </li>
                <li>
                  <CircleIcon
                    style={{
                      fontSize: "small",
                      color: "var(--firstbackground)",
                    }}
                  />{" "}
                  Don’t miss this exclusive offer!
                </li>
              </ul>
            </AccordionDetails>
          </Accordion>
          <Accordion style={{ width: "100%", margin: "10px 0px" }}>
            <AccordionSummary
              expandIcon={
                <ExpandMoreIcon style={{ color: "var(--firstbackground)" }} />
              }
              aria-controls="product-description-content"
              id="product-description-header"
              style={{
                backgroundColor: "var(--highlight)",
                color: "var(--firstbackground)",
                fontSize: "16px",
              }}
            >
              <Typography style={{ fontWeight: "600" }}>Shipping</Typography>
            </AccordionSummary>
            <AccordionDetails
              style={{
                padding: "16px",
                backgroundColor: "var(--highlight)",
                color: "var(--firstbackground)",
                fontSize: "16px",
              }}
            >
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                <li>
                  <CircleIcon
                    style={{
                      fontSize: "small",
                      color: "var(--firstbackground)",
                    }}
                  />{" "}
                  Express shipping.
                </li>
                <li>
                  <CircleIcon
                    style={{
                      fontSize: "small",
                      color: "var(--firstbackground)",
                    }}
                  />{" "}
                  No questions asked 15 days return policy.
                </li>
                <li>
                  <CircleIcon
                    style={{
                      fontSize: "small",
                      color: "var(--firstbackground)",
                    }}
                  />{" "}
                  6 month warranty.
                </li>
                <li>
                  <CircleIcon
                    style={{
                      fontSize: "small",
                      color: "var(--firstbackground)",
                    }}
                  />{" "}
                  Shipping nationally to all over countries.
                </li>
                <li>
                  <CircleIcon
                    style={{
                      fontSize: "small",
                      color: "var(--firstbackground)",
                    }}
                  />{" "}
                  Brand owned and marketed by: Rajpati Enterprisers, Cuttack,
                  Odisha - 753009.
                </li>
              </ul>
            </AccordionDetails>
          </Accordion>
          <span className="Mrpprice">
            <span className="price"> Rs.{product.ProductPrice}/-</span>
            <span className="Mrp">
              {(
                product.ProductPrice +
                (product.ProductPrice * 30) / 100
              ).toFixed(2)}
              /-
            </span>{" "}
            {`   `}Incl. of all taxes
          </span>
          <div className="offPrice">Save  Rs.{((product.ProductPrice * 30) / 100).toFixed(2)}/-</div>
          <div className="addcart">
            <Button
              variant="contained"
              className="add-to-cart"
              color="inherit" // This removes the default Material-UI color
              onClick={() => addtocart(product)}
              startIcon={<ShoppingCartIcon />}
            >
              Add to Cart
            </Button>
          </div>
        </div>
      </div>

      <Shopbycat />
      <Footer />
      {isMobile ? <SimpleBottomNavigation /> : ""}
    </>
  );
};

export default Productdetail;
